<div [formGroup]="form" class="upload-file mb-3">
  <input
    (change)="handleFileInput($event)"
    #input
    type="file"
    [accept]="accept"
    [multiple]="allowMultiple"
    hidden
  />
  <label
    *ngIf="title"
    class="form-label"
    [class.required]="form.get(controlName)?.hasValidator(Validators.required)"
  >
    {{ title }}
  </label>
  <a
    class="input-area drop-zone"
    [class.dragging-over]="isDraggingOver"
    (click)="handleInputFileClick()"
    (dragover)="handleDragOver($event)"
    (dragleave)="handleDragLeave($event)"
    (drop)="handleDrop($event)"
  >
    <div class="drop-zone-placeholder">
      <p *ngIf="!files.length && !placeholder">
        Drag & drop {{ allowMultiple ? "files" : "file" }} here or click to
        upload
      </p>
      <p *ngIf="placeholder">{{placeholder}}</p>
      <img src="./assets/images/upload-icon.png" alt="Upload Icon" />
    </div>
  </a>

  <ng-container *ngIf="!isLoading; else loading">
    <ul class="file-list" *ngIf="form.value[controlName]?.length">
      <li
        *ngFor="let file of form.value[controlName]; let i = index"
        class="file-item"
      >
        {{ file.name }}
        <button type="button" class="remove-file-btn" (click)="removeFile(i)">
          <img src="./assets/images/trash2-fill.svg" alt="Remove" />
        </button>
      </li>
    </ul>
  </ng-container>

  <ng-template #loading>
    <app-skeleton-loader height="20px" width="100%"></app-skeleton-loader>
  </ng-template>

  <p class="form-error mt-3" *ngIf="errorMessage">{{ errorMessage }}</p>
</div>
